
const can = (user,permission) => (user?.permissions || []).find((p) => p==permission) ? true :false;

export default can;